(function() {
    'use strict';

    angular
        .module('bhsApp')
        .controller('tableauNombreEtablissementExploitationAvecAvisDefavorable', tableauNombreEtablissementExploitationAvecAvisDefavorable);

    tableauNombreEtablissementExploitationAvecAvisDefavorable.$inject = ['$scope', '$state', 'ParseLinks', 'AlertService'];

    function tableauNombreEtablissementExploitationAvecAvisDefavorable ($scope, $state, ParseLinks, AlertService) {
        var vm = this;




    }
})();
